import React, { useEffect, useState } from "react";
import TaiwanIcon from "../../../assets/images/Icons/Taiwan.svg";
import CambodiaIcon from "../../../assets/images/Icons/Cambodia.svg";
import GrabpoolsIcon from "../../../assets/images/Icons/Grabpools.svg";
import ChinaIcon from "../../../assets/images/Icons/China.svg";
import SydneyIcon from "../../../assets/images/Icons/Sydney.svg";
import MangoliaIcon from "../../../assets/images/Icons/Mongolia.svg";
import SingaporeIcon from "../../../assets/images/Icons/Singapore.svg";
import JapanIcon from "../../../assets/images/Icons/Japan.svg";
import HongkongIcon from "../../../assets/images/Icons/Hongkong.svg";
import NusantaraIcon from "../../../assets/images/Icons/Nusantara.svg";
import { FaCaretDown, FaSyncAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserBalance,
  getUserProfile,
  setCommonConfig,
  setCurrentStep,
  setMultiCommonConfig,
} from "../../../redux/actions";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../helpers/global_helper";
import { useNavigate, useParams } from "react-router-dom";
import { formatPrice } from "../../NumberFormat";
import { withTranslation } from "react-i18next";
import UseBodyScrollLock from "../../Popups/UseBodyScrollLock";
import ChinaFourD from "../../../assets/images/Icons/China-4D.svg";
import Macau from "../../../assets/images/Icons/Macau.svg";
import MacauMFourD from "../../../assets/images/Icons/Macau-M4D.svg";
import MalaysiaPools from "../../../assets/images/Icons/Malaysia-pools.svg";
import OkasaPools from "../../../assets/images/Icons/Osaka-pools.svg";
import SigonPools from "../../../assets/images/Icons/Saigon-pools.svg";
import SingaporeFortyFive from "../../../assets/images/Icons/Singapore-45.svg";
import Taipei from "../../../assets/images/Icons/Taipei.svg";
import ThailandPools from "../../../assets/images/Icons/Thailand-pools.svg";
import MyanmarPools from "../../../assets/images/Icons/myanmar.png";
import { MdKeyboardArrowRight } from "react-icons/md";
import { TbBulb } from "react-icons/tb";
import CoachMarkPopup from "../../Popups/CoachMarkPopup";
import Korea from "../../../assets/images/Icons/korea.svg";

const HeaderLeftMenu = (props) => {
  const { setLoginHeader } = props;
  const { game_id } = useParams();

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [marketList, setMarketList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({});
  const user_profile = useSelector((state) => state.UserProfile);
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
  const marketIcon = {
    TW: TaiwanIcon,
    GP: GrabpoolsIcon,
    MC: CambodiaIcon,
    SGP: SingaporeIcon,
    JPN: JapanIcon,
    CN: ChinaIcon,
    SD: SydneyIcon,
    MW: MangoliaIcon,
    HK: HongkongIcon,
    NP: NusantaraIcon,
    // added new markets
    C4: ChinaFourD,
    MA: MacauMFourD,
    QN: Macau,
    MY: MalaysiaPools,
    OS: OkasaPools,
    SN: SigonPools,
    SP: SingaporeFortyFive,
    TP: Taipei,
    TD: ThailandPools,
    MR: MyanmarPools,
    KR: Korea,
  };
  const [time, setTime] = useState("");
  // useEffect(() => {
  //   const updateClock = () => {
  //     setTime(
  //       new Date().toLocaleTimeString("en-US", {
  //         hour12: false,
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         second: "2-digit",
  //         timeZone: "Asia/Jakarta",
  //       })
  //     );
  //   };

  //   const intervalId = setInterval(updateClock, 1000);

  //   // Cleanup interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, []);


  useEffect(() => {
    if (user_balance?.serverTime) {
      setTime(user_balance.serverTime);
    }
  }, [user_balance?.serverTime]);


  useEffect(() => {
    if (!time) return;

    const intervalId = setInterval(() => {
      setTime((prev) => {
        if (!prev) return prev;

        let [h, m, s] = prev.split(":").map(Number);

        s++;
        if (s === 60) { s = 0; m++; }
        if (m === 60) { m = 0; h++; }
        if (h === 24) h = 0;

        return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [time]);

  const marketDD = () => {
    makeAjax(url.TOGEL_API.marketDD, {}, url.TOGEL_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      if (response.data.length === 0) {
        console.info("No market available");
        navigate("/no-games");
        return;
      }
      // if (response.data.length == 0) {
      //   navigate("/blockUser");
      //   return;
      // }
      setMarketList(response.data);
      dispatch(setCommonConfig({ key: "marketList", value: response.data }));

      const activeGameId = localStorage.getItem("activeGameId") ?? response.data[0];
      const countryFromActiveGameId = response.data.filter(
        (data1) => data1?.game_id == activeGameId
      );
      handleCountrySelect(countryFromActiveGameId[0] ?? response.data[0]);
      const storedCountry = localStorage.getItem("country");
      const savedCountry = storedCountry ? JSON.parse(storedCountry) : null;
      setDropdownVisible(false);
      setSelectedCountry(savedCountry ?? response.data[0]);
      const set_gameId =
        (savedCountry && savedCountry.game_id) || response.data[0].game_id;
      const set_gameName =
        (savedCountry && savedCountry.game_name) || response.data[0].game_name;
      const set_gameCode =
        (savedCountry && savedCountry.game_code) || response.data[0].game_code;
      dispatch(setCommonConfig({ key: "country_name", value: set_gameName }));
      dispatch(setCommonConfig({ key: "game_code", value: set_gameCode }));
      dispatch(setCommonConfig({ key: "gameId", value: set_gameId }));

      setTimeout(() => {
        if (marketIcon) {
          setLoginHeader(true);
        }
      }, 2000);
    });
  };

  useEffect(() => {
    marketDD();
  }, []);

  const coachMarkHandle = () => {
    makeAjax(url.PLAYER_API.getCoachDetails, {}, url.PLAYER_MS_EXT)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        if (response.data.value === 0) {
          dispatch(setCurrentStep(0))
        }
        else (dispatch(setCurrentStep(-1))
        )
      }).catch((error) => {
        console.error("Error fetching CoachMark status:", error);
      });
  }

  useEffect(() => {
    let reqData = {};

    makeAjax(url.PLAYER_API.getCoachDetails, reqData, url.PLAYER_MS_EXT)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        if (response.data.value === 0) {
          dispatch(setCurrentStep(0))
        }
        else {
          dispatch(setCurrentStep(-1))

        }
      }).catch((error) => {
        console.error("Error fetching CoachMark status:", error);
      });


  }, []);

  const handleCountrySelect = (country) => {
    coachMarkHandle();
    localStorage.setItem("country", JSON.stringify(country));
    localStorage.setItem("activeGameId", JSON.stringify(country?.game_id));

    setSelectedCountry(country);
    let t = {
      country_name: country.game_name,
      gameId: country.game_id,
      game_id: country.game_id,
      country_code: country.game_code,
    };
    dispatch(setMultiCommonConfig(t));
    toggleDropdown();


    // coachMarkHandle();

  };
  UseBodyScrollLock(dropdownVisible);
  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  useEffect(() => {
    dispatch(getUserProfile());
    dispatch(getUserBalance());
  }, []);

  const handleRefreshClick = () => {
    setIsRefreshing(true);
    localStorage.setItem("refBtnVal", 1);
    const currentTime = new Date().getTime();
    const timeSinceLastClick = (currentTime - lastClickTime) / 1000;

    if (timeSinceLastClick < 8) {
      const remainingTime = Math.ceil(8 - timeSinceLastClick);
      setIsRefreshing(false);
      const msgName = props.t("try_again_after_8_second");
      const messageParts = msgName.split("8");
      showMessage(
        `${messageParts[0]}${remainingTime}${messageParts[1]}`,
        "error",
        "Message"
      );
    } else {
      dispatch(getUserBalance());
      setLastClickTime(currentTime);
      setTimeout(() => {
        setIsRefreshing(false);
        localStorage.setItem("refBtnVal", 0);
      }, 1000);
    }
  };
  const clickIcon = () => {
    // if (marketStatus.marketStatus == 0 || marketCloseStatus == 0) {
    //   dispatch(setCurrentStep(-1))

    // }
    dispatch(setCommonConfig({ key: "gameType", value: "4d3d2d" }));
  };

  return (
    <div className="header-left-menu">
      {/* <div className="left-menu custom-tooltip-wrapper "> */}
      <div
        className={`left-menu custom-tooltip-wrapper ${currentStep === 0 ? "highlighted" : ""}`} >
        <div className="logo-container">
          {selectedCountry && (
            <img
              src={marketIcon[selectedCountry.game_code]}
              alt={selectedCountry.game_name}
              className="logo"
              onClick={clickIcon}
            />
          )}
        </div>

        {/* <div className="custom-tooltip">
          <div className="quick-tip">
            <TbBulb /><span>Quick tip 1/11</span>
            </div>
            <div className="text">Markets</div>
            <p className="market-bet">Select your betting market.</p>
            <div className="custom-action">
              <div className="custom-bet">SKIP ALL</div>
              <div className="custom-bet">NEXT<div className="right-arr"><MdKeyboardArrowRight /></div></div>
            </div>
          
          <span className="custom-tooltip-arrow"></span>
        </div> */}
        {currentStep === 0 && <CoachMarkPopup />}
        {/* <CoachMarkPopup /> */}
        {/* <div className="dropdown-overlay"></div> */}

        <div className="market-info">
          <h5 onClick={toggleDropdown}>
            {/* <h5 onClick={() => { toggleDropdown(); marketDD(); }}> */}
            {selectedCountry && selectedCountry.game_name}
            <FaCaretDown
              style={{ marginLeft: "2px", fontSize: "20px", color: "#71B3DE" }}
            />
          </h5>
          <div className={`dropdown-content ${dropdownVisible ? "show" : ""}`}>
            {marketList.map((country, index) => (
              <a
                href="javascript:void(0)"
                key={index}
                onClick={() => handleCountrySelect(country)}
              >
                <img
                  src={marketIcon[country.game_code]}
                  alt={country.game_name}
                />
                {country.game_name}
              </a>
            ))}
          </div>
          {dropdownVisible && (
            <div className="dropdown-overlay" onClick={toggleDropdown} />
          )}
          <p>{time}</p>
        </div>
      </div>
      {currentStep === 0 && <div className="custom-overlay"></div>}

      {/* <div className="user-info">
        <p>{props.t('user')}: {user_profile.nickname}</p>
        <p>
          {props.t('balance')}: {user_profile.curr} {formatPrice(user_balance.coin)}
          <span className="refresh-icon">
            <FaSyncAlt
              className={isRefreshing ? "refreshing" : ""}
              onClick={handleRefreshClick}
            />
          </span>
        </p>
      </div> */}
    </div>
  );
};

export default withTranslation()(HeaderLeftMenu);
